export const BRAND_NAME = 'Личный кабинет Sminex'
export const SOMETHING_WENT_WRONG = 'Что-то пошло не так'
export const SOMETHING_WENT_WRONG_DESCRIPTION =
  'Мы уже работаем над проблемой. Приносим извинения за неудобства'

export enum ScreenSize {
  Xxs = 'xxs',
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
  Xxl = 'xxl'
}
